type FileType = "image" | "pdf";

export const getFileType = (mimeType: string): FileType | undefined => {
  const ext = mimeType.toLowerCase().split("/")[1];

  // https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types#common_image_file_types
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  // ignoring: jfif, pjpeg, pjp
  switch (ext) {
    case "apng":
    case "avif":
    case "gif":
    case "jpeg": // jpeg and jpg are the same
    case "png":
    case "svg":
    case "webp":
      return "image";

    case "pdf":
      return "pdf";

    default:
      return undefined;
  }
};
